// extracted by mini-css-extract-plugin
module.exports = {"boxBtn":"_271eBlUz5l6T8NOCshWU5H","boxBtnRemove":"_3b2jwu-_szXCvZROfttANN","boxBtnClose":"_3m-AzJvHld1R86OUXk6_-l"};